import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Auth, Storage } from 'aws-amplify';

@Component({
  selector: 'tag-data',
  templateUrl: './tag-data.component.html',
  styleUrls: ['./tag-data.component.css'],
})
export class TagDataComponent {
  @Input() tableData: any;
  @Input() uid: string;
  loadingFlag: boolean = false;
  save() {
    console.log('save');

    // save the data as json file in s3
    this.uploadJsonToS3();
  }

  async uploadJsonToS3() {
    Auth.currentCredentials();
    Storage.configure({ 
      level: 'private' ,
      bucket: 'doc2txt-tag-data160233-dev'
    });

    const fileName = `${this.uid}.json`;
    this.loadingFlag = true;
    try {
      const result = await Storage.put(
        fileName,
        JSON.stringify({data:this.tableData, uid:this.uid}),
        {
          contentType: 'application/json',
        }
      );
      console.log('Successfully uploaded JSON to S3:', result);
    } catch (error) {
      console.error('Error uploading JSON to S3:', error);
      alert(error);
    } finally {
      this.loadingFlag = false;
    }
  }

  async list() {
    const files = await Storage.list('');

    alert(JSON.stringify(files, null, 2));
  }
}
